import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";
import { registerAccountApp } from "@nexxt/account-ui";
import { applyPreferences, registerErrorTexts, settleSkippedViewTransitions } from "@nexxt/app-kit";
import { registerPartyClient } from "@nexxt/party-ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { accountClient } from "./account-client";
import { queryClient } from "./api";
import { errorTexts } from "./errors";
import { partyClient } from "./party-client";
import { router } from "./router";

registerErrorTexts(errorTexts);
registerAccountApp({
  client: accountClient,
  product: "frontrow",
  turnstileSiteKey: import.meta.env.NEXXT_TURNSTILE_SITE_KEY,
});
registerPartyClient(partyClient);
settleSkippedViewTransitions();
applyPreferences();
matchMedia("(prefers-color-scheme: dark)").addEventListener("change", applyPreferences);

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
